import type { RequestConfig } from '@customTypes/index';
import type { PhotoUpdateDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type UpdatePhotoItem = {
  photoId: string;
  data: PhotoUpdateDto;
};

export type UpdatePhotoItemParams = RequestConfig<UpdatePhotoItem>;

export const updatePhotoItem = async ({
  params,
  config
}: UpdatePhotoItemParams) =>
  api.put(`/api/photos/${params.photoId}`, params.data, config);
